import clsx from "clsx"
import { ReactNode } from "react"

interface Props {
  children: ReactNode
  className?: string
  maxWidthClassName?: string
  tag?: "header" | "section" | "div" | "footer"
  [props: string]: any
}

const Container = ({
  children,
  className,
  maxWidthClassName = "max-w-7xl",
  tag: Tag = "div",
  ...props
}: Props) => (
  <Tag
    className={clsx(
      "relative container mx-auto w-full px-4 md:px-8",
      maxWidthClassName,
      className
    )}
    {...props}
  >
    {children}
  </Tag>
)

export default Container
